module.exports = __webpack_public_path__ + "img/home-10-2.704135c8.png";